module.exports = __webpack_public_path__ + "static/media/sobremesas.338a5c76.png";